/**
 * Keeps the results count at the top of the search page in step with the product results.
 *
 * The count can't be rendered next to the search form directly: on a mixed search the products come
 * from a separate request made by `search-result-panel`, so the document holding the heading doesn't
 * know how many products there are (only Shopify's total across products, pages and articles, which
 * is a different number).
 *
 * The results publish their own count, already pluralised by Liquid, and it gets copied up here as
 * soon as it's in the DOM. Nothing is formatted in JavaScript: `search.results_count` has up to five
 * plural forms depending on the locale.
 */
(() => {
  // If the products never arrive (a failed request), fall back to what the server rendered rather
  // than leaving the visitor with no count at all.
  const TIMEOUT = 10000;

  const target = document.querySelector('[data-search-results-count]:not([data-count-bound])');

  if (!target) {
    return;
  }

  const panel = document.getElementById(target.getAttribute('data-source-panel') || '');

  if (!panel) {
    return;
  }

  // Marked rather than guarded on a global, so that a section re-render in the theme editor binds
  // the count it just rendered instead of holding on to the element it replaced.
  target.setAttribute('data-count-bound', 'true');

  const apply = () => {
    const source = panel.querySelector('[data-search-results-count-source]');

    if (!source) {
      return false;
    }

    target.textContent = source.textContent.trim();

    return true;
  };

  // Already there when the whole page is one request, which is the case whenever the search only
  // turned up products.
  if (apply()) {
    return;
  }

  let timer = null;

  const settle = (expired) => {
    clearTimeout(timer);
    observer.disconnect();

    if (expired && target.textContent.trim() === '') {
      target.textContent = target.getAttribute('data-count-fallback') || '';
    }
  };

  const observer = new MutationObserver(() => {
    if (apply()) {
      settle();
    }
  });

  timer = setTimeout(() => settle(true), TIMEOUT);
  observer.observe(panel, { childList: true, subtree: true });
})();
